import React from 'react';
import { CopyLink } from './CopyLink';
import { Typography } from '../../style/Typography.js';

export function Share({ textToCopy, toastText }) {
  return (
    <ul style={{ listStyle: 'none', display: 'flex', margin: '30px 0' }}>
      <li>
        <Typography variant="h6">Share:</Typography>
      </li>
      <li>
        <CopyLink
          onClick={e => e.stopPropagation()}
          textToCopy={textToCopy}
          toastText={toastText}
        />
      </li>
    </ul>
  );
}
